import { useState, useRef, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API_URL } from '@/config/api';

export const useImageUpload = (onSuccess) => {
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const uploadFiles = useCallback(async (files) => {
    const imgs = Array.from(files).filter(f => f.type.startsWith('image/'));
    if (!imgs.length) return toast.error('請選擇圖片');
    setUploading(true);
    try {
      for (const file of imgs) {
        const fd = new FormData();
        fd.append('file', file);
        await axios.post(`${API_URL}/upload`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }
      toast.success(`上傳了 ${imgs.length} 張`);
      await onSuccess();
    } catch {
      toast.error('上傳失敗');
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  }, [onSuccess]);

  return { uploadFiles, uploading, fileInputRef };
};
